import React from "react";
import { Container, CircularProgress } from "@mui/material";

const SubscriptionLoader = () => (
  <Container maxWidth="lg" sx={{ py: 4, display: 'flex', justifyContent: 'center' }}>
    <CircularProgress />
  </Container>
);

export default SubscriptionLoader;
